(function(ns) {
	"use strict";

	var util = ns.util;

	util.component("step-view", {
		props: {
			step: String,
			stepDoneNum: Number,
		},
	});

})(CE);
